<template>
<v-main>
    <v-flex row wrap mt-3 px-5>
        <h1>
        <p class="text-sm-left font-weight-bold">Cadastrar Serviço </p>
         <!-- {{recepcionista}} -->
        </h1>
    </v-flex>

<v-flex row wrap mt-3 px-5>
<form>
    <v-text-field
      :counter="10"
      label="Nome do Serviço"
      required
    ></v-text-field>

    <v-select
      :items="['Local 1', 'Local 2', 'Local 3', 'Local 4']"
      label="Local"
      required
    ></v-select>

    <v-checkbox
      label="Você concorda?"
      required
    ></v-checkbox>

    <v-btn @click="">submit</v-btn>
    <v-btn @click="clear">limpar</v-btn>
  </form>

</v-flex>

</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorService from '../../../services/administrador.service'

export default {
  name: 'cadastrarServicos',
  data () {
    return {

    }
  },
  components: {
    // HelloWorld
  },
  methods: {
    cadastrarServico () {
      console.log('em retornar chamadas...')
      administradorService.administrador
        .retornarChamadas(this.user.idUnidade, this.user.idLocal)
        .then(rsp => {
          console.log('rsp oi:')
          //  console.log(rsp.data.listaChamadas);
          this.listaChamadas = rsp.data.listaChamadas
          console.log(this.listaChamadas)
          // console.log(this.listaChamadas);
          // this.servicoTeste = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    }
  },
  created () {
    console.log('created...')
  }
}
</script>
